export default __webpack_public_path__ + "static/media/game_3_m.52346d00.png";